import { render, staticRenderFns } from "./PracticeList.vue?vue&type=template&id=5b06b27c&"
import script from "./PracticeList.vue?vue&type=script&lang=ts&"
export * from "./PracticeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports